import path from 'path-browserify';
import React from 'react';
export const Image = ({ imagePath, className }) => {
    const imageExt = path.extname(imagePath) || '.png';
    const imageBasePath = imagePath.replace(imageExt, '');
    const imageDesc = path.basename(imageBasePath);
    return imageExt === '.png' ? (React.createElement("img", { className: className, srcSet: `${imageBasePath}.png,
        ${imageBasePath}@2x.png 2x,
        ${imageBasePath}@3x.png 3x`, alt: `${imageDesc} icon` })) : imageExt === '.svg' ? (React.createElement("img", { className: className, src: `${imageBasePath}.svg`, alt: `${imageDesc} icon` })) : null;
};
